var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUserBig = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.003 2C9.24076 2 7.00151 4.23858 7.00151 7C7.00151 9.76142 9.24076 12 12.003 12C14.7653 12 17.0045 9.76142 17.0045 7C17.0045 4.23858 14.7653 2 12.003 2ZM20.0054 16.76L21.896 20.55C22.052 20.8595 22.0366 21.2277 21.8552 21.5231C21.6739 21.8185 21.3524 21.999 21.0057 22H3.0003C2.6536 21.999 2.33217 21.8185 2.1508 21.5231C1.96944 21.2277 1.95401 20.8595 2.11003 20.55L4.0006 16.76C4.84857 15.0683 6.57916 14.0001 8.47195 14H15.5341C17.4269 14.0001 19.1575 15.0683 20.0054 16.76Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user_big.94c3e3a6.svg";
export { ForwardRef as ReactComponent };